import { Dispatch, SetStateAction } from 'react';
import { utils, writeFile } from 'xlsx';

export const parseCSVToJson = (
  event: Event,
  setData: React.Dispatch<React.SetStateAction<string[][]>>,
) => {
  if (!event.target) return;
  if (!('result' in event.target)) return;
  const result = event.target.result as string;
  const json: string[][] = [];
  const rows = result.split(/\r\n|\n/);
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    const str = r.replace(/“|”/g, '"');
    const arr: string[] = [];
    const arrX = str.split('');
    let o = 0;
    let q = false;
    for (let j = 0; j < arrX.length; j++) {
      const k = arrX[j];
      if (k === ',' && q === false) {
        arr.push(str.substring(o, j));
        o = j + 1;
      }
      if (q === false && k === '"') {
        q = true;
        continue;
      }
      if (q === true && k === '"') {
        q = false;
      }
    }
    arr.push(str.substring(o, arrX.length));
    for (let j = 0; j < arr.length; j++) {
      arr[j] = arr[j].replace(/"/g, '');
    }
    json.push(arr);
  }
  const data: string[][] = json.map(item => item.filter(Boolean));
  setData(prev => [...prev, ...data]);
};

export const handleUploadCsv = (
  e: React.ChangeEvent<HTMLInputElement>,
  setterFunc: Dispatch<SetStateAction<string[][]>>,
) => {
  if (!e.target.files) return;
  const file = e.target.files[0];
  if (!file) return;
  const type = file.type.split('/')[1];
  if (type !== 'xlsx') return;
  const reader = new FileReader();
  reader.onload = event => {
    parseCSVToJson(event, setterFunc);
  };
  reader.readAsText(file);
};

export const handleExportExcel = (list: string[][]) => {
  if (list.length === 0) return;

  const worksheet = utils.aoa_to_sheet(list);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  writeFile(workbook, '下載.xlsx');
};

export const buildData = <T extends object>(
  dataList: T[],
  titleList: string[],
) => {
  const arrayData: string[][] = [];
  const arrayTitle = Object.keys(dataList[0]);
  arrayData.push(titleList ? titleList : arrayTitle);
  dataList.forEach(data => {
    // 執行雙層 array
    const items: string[] = [];
    arrayTitle.forEach(title => {
      let item = data[title as keyof T] as string | keyof T;
      item = Array.isArray(item) ? item.join(';') : item;
      items.push(<string>item);
    });
    arrayData.push(items);
  });
  return arrayData;
};
